import { EditCapacitiesPopup } from './EditCapacitiesPopup';

export default EditCapacitiesPopup;
